// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"945cd99fead1d4058b43","655":"c58867a007ff7bc79629"}[chunkId] + ".js";
};